<!--============================
=            FOOTER            =
=============================-->

<template>
  <v-footer height="auto" :color="appConfig.dark?'#303030':'#ffffff'" class="companyFooter">
    <v-layout justify-center row wrap>
      <!-- <v-btn v-for="link in links" :key="link" color="primary" flat round>{{ link }}</v-btn>
      <v-flex py-3 text-xs-center primary--text xs12>&copy;2019&nbsp;&nbsp;NExT-e Solutions</v-flex> -->
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      // 'Home',
      // 'About Us',
      // 'Team',
      // 'Services',
      // 'Blog',
      // 'Contact Us'
    ]
  })
};
</script>
<style scoped>
.companyFooter {
  border-top: solid 1px #444 !important;
}
</style>


<!--====  End of FOOTER  ====-->



// WEBPACK FOOTER //
// src/components/ui/footer/companyFooter.vue